import { createContext } from 'react'
import { ICompletedContextState } from '../type/modelType'
import { initialState } from './hooks'

export const AppContext = createContext(initialState as ICompletedContextState)
